export default __webpack_public_path__ + "static/media/marker_green.3fecd466.svg";